import Input from "@/pages/components/form/horizontal/input.vue";
import Email from "@/pages/components/form/horizontal/email.vue";
import Password from "@/pages/components/form/horizontal/password.vue";
import Radio from "@/pages/components/form/horizontal/radio.vue";
import Price from "@/pages/components/form/horizontal/price.vue";
import Checkbox from "@/pages/components/form/horizontal/checkbox.vue";
import FormGroup from "@/pages/components/form/horizontal/form-group.vue";
import YesNo from "@/pages/components/form/horizontal/yesno.vue";
import Phone from "@/pages/components/form/horizontal/phone.vue";
import Textarea from "@/pages/components/form/horizontal/textarea.vue";
import Select from "@/pages/components/form/horizontal/select.vue";
import Date from "@/pages/components/form/horizontal/date.vue";
import DateTime from "@/pages/components/form/horizontal/datetime.vue";
import Color from "@/pages/components/form/horizontal/color.vue";
import Wysiwyg from "@/pages/components/form/horizontal/wysiwyg.vue";
import MultipleRadios from "@/pages/components/form/horizontal/multiple-radios.vue";
import MultipleChecks from "@/pages/components/form/horizontal/multiple-checks.vue";
import Signature from "@/pages/components/form/horizontal/signature.vue";
import File from "@/pages/components/form/horizontal/file.vue";
import Website from "@/pages/components/form/horizontal/website.vue";
import Username from "@/pages/components/form/horizontal/username.vue";
import Pictures from "@/pages/components/form/horizontal/pictures.vue";
import Icon from "@/pages/components/form/horizontal/icon.vue";
import AssetableTable from '@/pages/assets/AssetableTable.vue'

export default {
	components: {
		Checkbox,
		Input,
		Radio,
		Email,
		Password,
		Price,
		FormGroup,
		YesNo,
		Phone,
		Textarea,
		Select,
		Date,
		DateTime,
		Color,
		Wysiwyg,
		MultipleRadios,
		MultipleChecks,
		File,
		Website,
		Username,
		Pictures,
		Icon,
		AssetableTable
	},
}